var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChatbotQuestionIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7719 5.71537C9.01141 5.14611 6.86692 2.98292 6.29658 0.227704C6.27376 0.0910815 6.1597 0 6 0C5.86312 0 5.74905 0.0910815 5.70342 0.227704C5.13308 2.98292 2.96578 5.14611 0.228137 5.71537C0.0912546 5.73814 0 5.85199 0 6.01138C0 6.14801 0.0912546 6.26186 0.228137 6.3074C2.98859 6.87666 5.13308 9.03985 5.70342 11.7723C5.72623 11.9089 5.8403 12 6 12C6.13688 12 6.25095 11.9089 6.29658 11.7723C6.86692 9.01708 9.03422 6.87666 11.7719 6.3074C11.9087 6.28463 12 6.17078 12 6.01138C12 5.85199 11.9087 5.73814 11.7719 5.71537Z",
    fill: "#97C2FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChatbotQuestionIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Chatbot_question_icon.350380deb4a43d61266c96819d5a0ef4.svg";